import { render, staticRenderFns } from "./the-australian-legal-system.vue?vue&type=template&id=03697b0e&scoped=true&"
import script from "./the-australian-legal-system.vue?vue&type=script&lang=js&"
export * from "./the-australian-legal-system.vue?vue&type=script&lang=js&"
import style0 from "./the-australian-legal-system.vue?vue&type=style&index=0&id=03697b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03697b0e",
  null
  
)

export default component.exports